/**
 * @generated SignedSource<<8774074126e0c0c6bbb16e72cb857693>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptTermsAndConditionsInput = {
  acceptTermsAndConditions: boolean;
  acceptedTermsAndConditionsId: string;
};
export type Profile_acceptTermsAndConditions_Mutation$variables = {
  input: AcceptTermsAndConditionsInput;
};
export type Profile_acceptTermsAndConditions_Mutation$data = {
  readonly acceptTermsAndConditions: {
    readonly user: {
      readonly id: string;
    };
  } | null;
};
export type Profile_acceptTermsAndConditions_Mutation = {
  response: Profile_acceptTermsAndConditions_Mutation$data;
  variables: Profile_acceptTermsAndConditions_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcceptTermsAndConditionsPayload",
    "kind": "LinkedField",
    "name": "acceptTermsAndConditions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_acceptTermsAndConditions_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Profile_acceptTermsAndConditions_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "19f12bca8d1a80ac07e2eccdfdf80bfd",
    "id": null,
    "metadata": {},
    "name": "Profile_acceptTermsAndConditions_Mutation",
    "operationKind": "mutation",
    "text": "mutation Profile_acceptTermsAndConditions_Mutation(\n  $input: AcceptTermsAndConditionsInput!\n) {\n  acceptTermsAndConditions(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c45297dd49a7b79b838667c0306c6f8";

export default node;
